<template>
    <Modal :show="showModal" :nowrap="true" :modalClass="'chat-modal-images'" :modalWrapClass="'chat-modal-overlay'" @close="$emit('close-modal')">
        <div class="chat-modal-images__close" @click="$emit('close-modal')">
            <svg class="wc-i" aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
        </div>
        <div class="chat-modal-images__wrap" v-if="showModal"
            @pointerdown="onStagePointerDown"
            @click="onStageClick">
            <div class="swiper-button-wrap prev" v-if="allChatImages.length > 1 && !mobile">
                <div class="swiper-button-prev btn-slider" ref="nextEl" v-if="isActiveMoodalSidebar">
                    <svg class="wc-i" aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>
                </div>
                <div class="swiper-button-prev btn-slider" ref="prevEl" v-else>
                    <svg class="wc-i" aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>
                </div>
            </div>
            <div class="swiper-button-wrap next" v-if="allChatImages.length > 1 && !mobile">
                <div class="swiper-button-next btn-slider" ref="prevEl" v-if="isActiveMoodalSidebar">
                    <svg class="wc-i" aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                </div>
                <div class="swiper-button-next btn-slider" ref="nextEl" v-else>
                    <svg class="wc-i" aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                </div>
            </div>
            <Swiper ref="swiperRef"
                :dir="swiperDir"
                :modules="swiperModules"
                :initial-slide="activeImageIndex"
                :navigation="{ prevEl, nextEl }"
                @slideChange="onSlideChange"
                @swiper="onSwiperInit"
                class="chat-modal-images__slider"
            >
                <SwiperSlide v-for="img in allChatImages" :key="img.id">
                    <img :src="img.base64 || img.original_url" :alt="img.original_name"/>
                </SwiperSlide>
            </Swiper>
        </div>
    </Modal>
  </template>
  
  <script>
import Modal from '/webpack-assets/vue/templates/chat/parts/ChatModal.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';

export default {
  components: {
    Modal,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      prevEl: null,
      nextEl: null,
      swiperModules: [Navigation],
      pointerStart: null,
    };
  },
  props: {
    showModal: {
        type: Boolean,
        default: false
    },
    mobile: {
        type: Boolean,
        default: false
    },
    isActiveMoodalSidebar: {
        type: Boolean,
        default: false
    },
    allChatImages: {
        type: Array,
        default: []
    },
    activeImageIndex: {
        type: Number,
        default: null
    }
  },
  mounted() {
    this.prevEl = this.$refs.prevEl;
    this.nextEl = this.$refs.nextEl;
  },
//   watch: {
//     showModal(val) {
//         if (!val) return;

//         this.$nextTick(() => {
//         this.prevEl = this.$refs.prevEl;
//         this.nextEl = this.$refs.nextEl;

//         const swiper = this.$refs.swiperRef?.swiper;
//         if (swiper) {
//             swiper.params.navigation.prevEl = this.prevEl;
//             swiper.params.navigation.nextEl = this.nextEl;
//             swiper.navigation.init();
//             swiper.navigation.update();
//         }
//         });
//     }
//   },
  computed: {
    swiperDir() {
        return this.isActiveMoodalSidebar ? 'rtl' : 'ltr';
    },
  },
  methods: {
    onStagePointerDown(e) {
      this.pointerStart = { x: e.clientX, y: e.clientY };
    },
    // Click on the empty area around the image closes the viewer (like the backdrop in difmark)
    onStageClick(e) {
      const start = this.pointerStart;
      this.pointerStart = null;
      // a swipe between slides is not a click
      if (start && Math.hypot(e.clientX - start.x, e.clientY - start.y) > 5) return;
      if (e.target.closest('img, .btn-slider')) return;
      this.$emit('close-modal');
    },
    onSwiperInit(swiper) {
        this.prevEl = this.$refs.prevEl;
        this.nextEl = this.$refs.nextEl;

        if (this.prevEl && this.nextEl) {
            swiper.params.navigation.prevEl = this.prevEl;
            swiper.params.navigation.nextEl = this.nextEl;
            swiper.navigation.init();
            swiper.navigation.update();
        }
    },
    onSlideChange(swiper) {
        const currentImage = this.allChatImages[swiper.activeIndex];
        if (currentImage) {
            this.$emit('active-img', currentImage.id);
        }
    }
  },
};
</script>

<style lang="scss">
    // Image viewer sits on a dark scrim (design P-Viewer), unlike the light dialogs
    .modal-overlay.chat-modal-overlay{
        z-index: 10001;
        background: rgba(11, 15, 23, 0.94);
    }
   .chat-modal-images{
    // full-viewport stage; the close button sits in the screen corner (design P-Viewer)
    width: 100vw !important;
    max-width: none !important;
    height: 100vh;
    height: 100dvh;
    max-height: none !important;
    padding: 72px 32px;
    box-sizing: border-box;
    border-radius: 0;
    background-color: transparent !important;
    box-shadow: none !important;
    overflow: visible !important;
    position: relative;
    // the padding area lets clicks through to the overlay, which closes the viewer
    pointer-events: none;
    > *{
        pointer-events: auto;
    }
    @media only screen and (max-width: 767px) {
        padding: 72px 0;
    }
    &__close{
        position: absolute;
        right: 16px;
        top: 16px;
        width: 44px;
        height: 44px;
        border-radius: 100%;
        z-index: 101;
        background: rgba(255, 255, 255, 0.12);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.2s;
        svg path{
            fill: #FFFFFF;
        }
        &:hover{
            background: rgba(255, 255, 255, 0.2);
        }
    }
    &__wrap{
        height: 100%;
        max-width: 1104px;
        margin: 0 auto;
        position: relative;
        .swiper-button-wrap{
            position: absolute;
            z-index: 100;
            height: 100%;
            width: 48px;
            top: 0;
            display: flex;
            align-items: center;
            @media only screen and (max-width: 991px) {
                display: none;
            }
            &.prev{
                left: 0;
            }
            &.next{
                right: 0;
            }
            .btn-slider{
                opacity: 1;
                transition: 0.4s;
            }
            // &:hover{
            //     .btn-slider{
            //         opacity: 1;
            //     }
            // }
        }
        .swiper-button-prev,
        .swiper-button-next{
            position: static;
            margin: 0;
            background-color: rgba(255, 255, 255, 0.12);
            color: #FFFFFF;
            width: 48px;
            height: 48px;
            border-radius: 100%;
            transition: background-color 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
            @media only screen and (max-width: 991px) {
                display: none;
            }
            &::after{
                content: none;
            }
            &.swiper-button-lock{
                display: none;
            }
            &.swiper-button-disabled{
                opacity: 0 !important;
            }
            &:hover{
                background-color: rgba(255, 255, 255, 0.2);
            }
            svg{
                width: 22px;
                height: 22px;
            }
        }
    }
    &__slider{
        height: 100%;
        margin: 0 72px;
        @media only screen and (max-width: 991px) {
            margin: 0;
        }
        .swiper-slide{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            &.swiper-slide-prev,
            &.swiper-slide-next{
                img{
                    opacity: 0;
                }
            }
            img {
                opacity: 1;
                max-width: 100%;
                max-height: 100%;
                width: auto;
                height: auto;
                object-fit: contain;
            }
        }
    }
   }
</style>